export default __webpack_public_path__ + "static/media/Icon_Hamburger.4c24bc28.svg";